/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';

import FeatureChooser, {
  type Feature,
} from 'bundles/academic-integrity/components/course-profiles/feature-form/FeatureChooser';
import { useProgramAdminTypeAndPermissionsContext } from 'bundles/enterprise-admin-program-catalog/components/ProgramAdminTypeAndPermissionsContextProvider';
import { TrackedButton } from 'bundles/enterprise-ui/components';

import _t from 'i18n!nls/enterprise-admin-drawers';

type Props = {
  onChange: (feature: Feature, checked: boolean) => void;
  gradedItemLocking: boolean;
  restrictCourseraCoachAccess: boolean;
  restrictCourseContentAccess: boolean;
  productId?: string;
};

export default function AcademicIntegrityFeaturesStep(props: Props) {
  const { onChange, gradedItemLocking, restrictCourseContentAccess, restrictCourseraCoachAccess, productId } = props;
  const [stepOpen, setStepOpen] = React.useState(false);
  const { programId, orgId, userId } = useProgramAdminTypeAndPermissionsContext();
  const openStep = () => {
    setStepOpen(!stepOpen);
  };

  return (
    <Grid container spacing={16} direction="column">
      <Grid item>
        <Typography2 variant="subtitleMedium" component="h4">
          {_t('Academic Integrity Features')}
        </Typography2>
        <Typography2 component="p" variant="bodySecondary">
          {_t('These academic integrity features will apply to the entire course.')}
        </Typography2>
      </Grid>
      {stepOpen ? (
        <Grid item>
          <FeatureChooser
            data={{ gradedItemLocking, restrictCourseContentAccess, restrictCourseraCoachAccess }}
            onChange={onChange}
          />
        </Grid>
      ) : (
        <Grid item>
          <TrackedButton
            trackingName="enterprise_admin_for_academic_integrity_edit_btn"
            trackingData={{
              userId,
              programId,
              orgId,
              productId,
            }}
            variant="secondary"
            onClick={openStep}
            data-testid="academic_integrity_edit_btn"
            size="small"
          >
            {_t('Edit')}
          </TrackedButton>
        </Grid>
      )}
    </Grid>
  );
}
